module.exports = __webpack_public_path__ + "./Winnie2_e47b18feb8f5f17da6585a397085c443.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Winnie2.png
// module id = 581
// module chunks = 0